import { message } from "antd";
import axios from "axios";
import { logFrontendApiError } from "./actions";

let headers = {
  "Content-Type": "application/json",
};

const axiosInstance = axios.create({
  headers,
  timeout: 1600000,
  baseURL: `${process.env.REACT_APP_API_HOST}/v1/`,
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const errorObj = error.response;

    const requestUrl = `${errorObj.config.baseURL}${errorObj.config.url}`;
    const responseStatus = errorObj.status;

    // if we are logging frontend error, don't error log it
    // we will end up in an infinite loop
    if (requestUrl.includes("log-frontend-error")) {
      return Promise.reject(error);
    }

    if (responseStatus === 200) {
      return Promise.reject(error);
    }

    const payload = {
      url: JSON.stringify(requestUrl),
      request_data: JSON.stringify(errorObj.config.data),
      request_method: JSON.stringify(errorObj.config.method),
      request_headers: JSON.stringify(errorObj.config.headers),
      response_status: JSON.stringify(responseStatus),
      response_data: JSON.stringify(errorObj.data),
      response_headers: JSON.stringify(errorObj.headers),
    }
    // if the response is not 200, log the error
    logFrontendApiError(payload).then(() => { }).catch((err) => {
      message.error(err?.response?.data?.message || "Something went wrong - try logging out and logging back in");
    });

    return Promise.reject(error);
  }
)

export default axiosInstance;
